import { Button, Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { EInvoicesDeactivatedEmptyState } from '../../../../assets/images'
import { E_INVOICING_STEP_TO_PATH } from '../../constants'
import { getEInvoicingBaseUrl } from '../../utils'
import { EInvoicingGenericStatus } from '../EInvoicingGenericStatus'

export const EInvoicingDeactivatedEmptyState = (): ReactElement => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()

  return (
    <EInvoicingGenericStatus
      title={t('e_invoice.kyc.step.status.deactivated.title')}
      illustration={EInvoicesDeactivatedEmptyState}
    >
      <Text colorVariant="secondary" alignment="center">
        {t('e_invoice.kyc.step.status.deactivated.subtitle')}
      </Text>
      <Space size="s24" />
      <Button
        fullWidth
        to={`${getEInvoicingBaseUrl(organization)}/${E_INVOICING_STEP_TO_PATH.COMPANY_INFO}`}
        variant="filled"
      >
        {t('e_invoice.kyc.step.status.deactivated.cta.primary')}
      </Button>
    </EInvoicingGenericStatus>
  )
}
